module.exports = __webpack_public_path__ + "img/D202004_1.764b9cc0.jpg";